import { Splash } from '@toilet-paper-games/ui';
import { ControllerGamePlayer } from '../components/ControllerGamePlayer';
import { useControllerAppModel } from '../models/ControllerAppModel';
import { observer } from 'mobx-react-lite';

export const GamePlayerPage = observer(() => {
  const appStore = useControllerAppModel();

  if (!appStore.selectedGame) return <div>no selected game</div>;

  if (!appStore.user) {
    return null;
  }

  return (
    <Splash>
      <ControllerGamePlayer lobbyGame={false} game={appStore.selectedGame} />
    </Splash>
  );
});
